import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="cng-notfound">
      <h1>Page not found</h1>
      <p>
        We couldn&rsquo;t find that page. It may have moved, or the link that brought
        you here may be out of date.
      </p>
      <Link to="/">Back to the homepage</Link>
    </div>
  );
}
